import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { ClientDetailRequestBody, ClientDetailResponse } from "./types";

export class ClientDetailAPI extends BaseAPI<
    ClientDetailRequestBody,
    ClientDetailResponse
> {
    protected route = ApiRoutes.client.detail;
    protected method = RequestMethod.GET;
    protected params = ["id"];
}
